import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { RouteStationMarkerObject, RouteStationMarkerObjectShort } from 'src/app/project/project-googlemaps/shared/interfaces/route-station-marker-object';
import { ProjectRouteStationWithParam } from 'src/app/project/shared/interfaces/project-route-station.class';
import { ProjectService } from 'src/app/project/shared/services/project.service';
import { DeviceDataService } from '../shared/services/device-data.service';
import { Subscription } from 'rxjs';
import { ProjectRouteStation } from 'src/app/project/shared/interfaces/project-route-station.interface';
import { environment } from 'src/environments/environment';
import { ProjectImageData } from 'src/app/project/shared/interfaces/project-image-data.interface';
import { GroupService } from 'src/app/project/shared/services/group.service';
import { ProjectDataService } from 'src/app/project/shared/services/project-data.service';
import { DeviceService } from '../shared/services/device.service';
import { DeviceTypeEnum, getDeviceTypeName } from '../shared/enums/device-type.enum';
import { RouteStationShort } from 'src/app/project/shared/interfaces/RouteStationShort';
import { FormControl } from '@angular/forms';
import { get } from 'lodash';
import {MapConsentService} from 'src/app/shared/map-consent/shared/map-consent.service'

@Component({
  selector: 'avs-device-map',
  templateUrl: './device-map.component.html',
  styleUrls: ['./device-map.component.css']
})
export class DeviceMapComponent implements OnInit, OnDestroy {

  public map?: google.maps.Map;
  public isMapConsentGiven: boolean = false;
  public mapConsentSubscription: Subscription;
  public center: google.maps.LatLngLiteral = { lat: 51.095123, lng: 10.241483 };
  public routeStationPins: RouteStationMarkerObject[] = []; /* wird ausgebaut */
  public routeStationPinsShort: RouteStationMarkerObjectShort[] = [];
  public routeStationMarkers: google.maps.marker.AdvancedMarkerElement[] = [];
  public routeStationsWithParams: ProjectRouteStationWithParam[] = [];
  public routeStationsSubscription: Subscription;
  public routeStations: ProjectRouteStation[] | undefined;
  public apiAddress: string = environment.apiAddress;
  public allImages: ProjectImageData[] = [];
  /* public groupsRouteStationsWithParams: ProjectRouteStationWithParam[] | undefined; */
  public projectRouteStationsWithParamSubscription: Subscription;
  public activeRouteStation: ProjectRouteStation | undefined;

  selectedFilter = new FormControl([-1]); // -1 = Alle
  filteredRouteStations: RouteStationShort[] = [];
  allRouteStations: RouteStationShort[] = [];
  /*   private previousSelection: number[] = [];
   */

  filters: any[] = [
    { value: -1, viewValue: 'Alle' },
    { value: 0, viewValue: getDeviceTypeName(DeviceTypeEnum.None) },
    { value: 1, viewValue: getDeviceTypeName(DeviceTypeEnum.AQ) + ' | AQ+MQ' },
    { value: 2, viewValue: getDeviceTypeName(DeviceTypeEnum.MQ) + ' | AQ+MQ' },
    { value: 3, viewValue: getDeviceTypeName(DeviceTypeEnum.Mixed) + ' | Kombi' },
    { value: 4, viewValue: getDeviceTypeName(DeviceTypeEnum.FuelCell) },
    { value: 5, viewValue: getDeviceTypeName(DeviceTypeEnum.LPCam) },
    { value: 6, viewValue: getDeviceTypeName(DeviceTypeEnum.DomeCam) },
  ];

  constructor(private projectService: ProjectService, deviceDataService: DeviceDataService, private groupService: GroupService, 
                    projectDataService: ProjectDataService, private deviceService: DeviceService, private mapConsentService:MapConsentService) {
      this.mapConsentSubscription = mapConsentService.isConsentGiven.subscribe(isConsentGiven => {
      this.isMapConsentGiven = isConsentGiven;
      if (!isConsentGiven) {
        this.destroyMap();
        return;
      }
      setTimeout(() => this.initMap());
    });
    this.routeStationsSubscription = deviceDataService.routeStations.subscribe(stations => {
      if (stations.length > 0) {
        this.routeStations = stations;
      }
    });
    this.projectRouteStationsWithParamSubscription = projectDataService.projectsRouteStationsWithParam.subscribe(routeStations => {
      if (routeStations)
        if (routeStations.length > 0) {
          /*    this.generateRouteStationPins(routeStations); */
          /* this.generateRouteStationPinsShort(routeStations); */
        }
    });
  }

  public ngOnInit(): void {
    this.deviceService.getAllRouteStationsWithParams().subscribe(routeStations => {
/*       console.log(routeStations);
 */      this.allRouteStations = routeStations;

      // Initialize filtered stations with all stations
      this.filteredRouteStations = [...routeStations];

      this.generateRouteStationPinsShort(this.filteredRouteStations);
    });

    this.selectedFilter.setValue([-1]);
   }
   
   public ngOnDestroy(): void {
     this.mapConsentSubscription.unsubscribe();
     this,this.routeStationsSubscription.unsubscribe();
     this.projectRouteStationsWithParamSubscription.unsubscribe();
   }

   public onRevokeMapConsentClicked(): void {
     this.mapConsentService.revokeConsent();
   }

  changeFilter(event: any) {
    const selectedValues = event.value;
    const alleValue = -1;

    if (selectedValues.includes(alleValue)) {
      // Wenn "Alle" ausgewählt ist, setze nur "Alle"
      this.selectedFilter.setValue([alleValue]);
    } else {
      // Wenn vorher "Alle" ausgewählt war und jetzt eine andere Auswahl getätigt wird,
      // entferne "Alle" aus der Auswahl und setze nur die neue Auswahl
      if (this.selectedFilter.value?.includes(alleValue)) {
        // Nur die letzte Auswahl setzen
        const lastSelected = selectedValues[selectedValues.length - 1];
        this.selectedFilter.setValue([lastSelected]);
      } else {
        // Normale Auswahl setzen
        this.selectedFilter.setValue(selectedValues);
      }
    }

    this.applyFilter();
  }

  applyFilter() {
    const selectedValues = this.selectedFilter.value || [];

    if (selectedValues.includes(-1) || selectedValues.length === 0) {
      // Show all stations
      this.filteredRouteStations = [...this.allRouteStations];
    }
    // Nur "Mixed" ist ausgewählt -> Nur Mixed
    else if (selectedValues.length === 1 && selectedValues[0] === DeviceTypeEnum.Mixed) {
      this.filteredRouteStations = this.allRouteStations.filter(station =>
        station.typ === DeviceTypeEnum.Mixed
      );
    }
    // AQ oder MQ (oder beide) gewählt -> jeweils auch Mixed addieren
    else {
      let filterTypes: DeviceTypeEnum[] = [];
      if (selectedValues.includes(DeviceTypeEnum.AQ)) {
        filterTypes.push(DeviceTypeEnum.AQ, DeviceTypeEnum.Mixed);
      }
      if (selectedValues.includes(DeviceTypeEnum.MQ)) {
        filterTypes.push(DeviceTypeEnum.MQ, DeviceTypeEnum.Mixed);
      }
      // Andere Typen einfach hinzufügen
      selectedValues.forEach((val: DeviceTypeEnum) => {
        if (![DeviceTypeEnum.AQ, DeviceTypeEnum.MQ, DeviceTypeEnum.Mixed].includes(val)) {
          filterTypes.push(val);
        }
      });
      // Duplikate entfernen
      filterTypes = Array.from(new Set(filterTypes));
      this.filteredRouteStations = this.allRouteStations.filter(station =>
        filterTypes.includes(station.typ)
      );
    }

    this.updateMapMarkers();
  }

  private clearMarkers(): void {
    this.routeStationMarkers.forEach(marker => {
      marker.map = null; // Remove marker from map
    });
    this.routeStationMarkers = []; // Clear the array
    this.routeStationPinsShort = []; // Clear pins array
  }

  // Update map markers based on current filter
  private updateMapMarkers(): void {
    if (!this.map) return;

    // Clear existing markers
    this.clearMarkers();

    // Generate new pins and markers with filtered data
    this.generateRouteStationPinsShort(this.filteredRouteStations);
  }

  private destroyMap(): void {
    this.clearMarkers();
    this.map = undefined;
  }
  async initMap() {
    if (!this.isMapConsentGiven || this.map)
      return;

    this.mapConsentService.loadGoogleMaps().then(async () => {
      const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

      this.map = new Map(document.getElementById("map") as HTMLElement, {
        zoom: 6,
        center: this.center,
        mapId: "avs-map",
        mapTypeControl: true,
        scaleControl: true,
        maxZoom: 18,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          mapTypeIds: ["roadmap", "terrain", "satellite", "hybrid"],
        },

        gestureHandling: "greedy",

      });
      if (this.routeStationPins!.length > 0) {
        this.setrouteStationMarkersShort(this.routeStationPinsShort!, 'routeStation');
      }
    });
  }
  /* OLD */


  public generateRouteStationPinsShort(routeStations: RouteStationShort[]): void {
    // Remove setTimeout if not needed for initial load
    const processStations = () => {
      this.routeStationPinsShort = [];

      // Filtere nur auf Stations mit longitude > 0
      const filteredStations = routeStations.filter(
        rs => rs.gps.longitude > 0
      );

      // If no valid stations, just clear and return
      if (filteredStations.length === 0) {
        return;
      }

      filteredStations.forEach((routeStation, index) => {
        this.routeStationPinsShort.push({
          lat: routeStation.gps.latitude,
          lng: routeStation.gps.longitude,
          content: 'content',
          id: routeStation.deviceId,
          online: routeStation.online,
          typ: routeStation.typ
        });

        // Wenn alle durch sind, Marker setzen
        if (index === filteredStations.length - 1) {
/*           console.log(this.routeStationPinsShort);
 */          this.setrouteStationMarkersShort(
            this.routeStationPinsShort!,
            'routeStation'
          );

          // Update map bounds to fit the filtered markers
          this.fitMapToMarkers(filteredStations);
        }
      });
    };

    // Use setTimeout only for initial load when map might not be ready
    if (this.routeStationMarkers.length === 0) {
      setTimeout(processStations, 2000);
    } else {
      processStations();
    }
  }

  // Separate method for fitting map bounds
  private fitMapToMarkers(stations: RouteStationShort[]): void {
    if (!this.map || stations.length === 0) return;

    const bounds = new google.maps.LatLngBounds();
    stations.forEach(rs =>
      bounds.extend({ lat: rs.gps.latitude, lng: rs.gps.longitude })
    );
    this.map.fitBounds(bounds);
  }

  setrouteStationMarkersShort(pins: RouteStationMarkerObjectShort[], markerType: string) {
    for (let i = 0; i < pins.length; i++) {
      if (this.map === undefined) return;
      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: { lat: pins[i].lat, lng: pins[i].lng },
        map: this.map,
        content: this.buildRouteStationContentSimple(pins[i]),
        title: pins[i].title
      });
      marker.addListener("click", () => {
        this.enterRouteStation(marker, pins[i]);
      }
      );
      this.routeStationMarkers.push(marker);
    }
  }


  buildRouteStationContentSimple(property: RouteStationMarkerObjectShort) {
    const content = document.createElement("div");
    content.classList.add("propertyRS-simple");

    // Container für Icon mit optionalem offline-overlay
    const iconContainer = document.createElement("div");
    iconContainer.classList.add("icon-container");

    // Offline-Overlay hinzufügen falls nötig
    if (!property.online) {
      iconContainer.classList.add("offline");
    }

    // Icon basierend auf Gerätetyp
    const iconImg = document.createElement("img");
    iconImg.style.height = "40px";
    iconImg.style.width = "40px";
    iconImg.src = this.getSimpleIconPath(property);

    iconContainer.appendChild(iconImg);
    content.appendChild(iconContainer);

    return content;
  }

  private getSimpleIconPath(property: RouteStationMarkerObjectShort): string {
    // Brennstoffzelle
    if (property.typ === DeviceTypeEnum.FuelCell) {
      return `${location.origin}/assets/icons/gas_meter.svg`;
    }
    // Kamera Typen
    if (property.typ === DeviceTypeEnum.LPCam) {
      return `${location.origin}/assets/icons/camera/icon_kamera_kennzeichen_center.svg`;
    }
    if (property.typ === DeviceTypeEnum.DomeCam) {
      return `${location.origin}/assets/icons/camera/icon_kamera_verkehr_center.svg`;
    }
    // LED Anzeigen
    if (property.typ === DeviceTypeEnum.AQ) {
      return `${location.origin}/assets/led_default.svg`;
    }
    // Radar/Messgeräte
    if (property.typ === DeviceTypeEnum.MQ /* || property.typ === DeviceTypeEnum.Mixed */) {
      return `${location.origin}/assets/icons/data-end-channel/radar_aq.svg`;
    }
    if (property.typ === DeviceTypeEnum.Mixed) {
      return `${location.origin}/assets/icons/data-end-channel/led_radar_default.svg`;
    }
    // Unbekannte Geräte
    if (property.typ === DeviceTypeEnum.None) {
      return `${location.origin}/assets/icons/icon_sst_eva.svg`;
    }
    // Fallback
    return `${location.origin}/assets/icons/icon_sst_eva.svg`;
  }

  public enterRouteStation(markerView: any, property: any) {
    let routeStation = this.routeStationsWithParams!.find(rs => rs.routeStation.samId === property.id);

  }

}
